import _extends from "@babel/runtime/helpers/extends";
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */

import React from 'react';
import { useTheme } from '../theme';
import { MobileSearchIconWrapper, DesktopSearchIconWrapper, SearchInputContainer, SearchInputField } from './search-input.styled';
import { SearchAnchorWrapper } from '../search-anchor';
import { SearchIcon } from '../icons';
import { IconButton } from '@atlaskit/button/new';
import { getInputSkeletonFocus } from './query-store';
import { SSRsearchInput } from './ssr-interactive-search-input';
const MAX_INPUT_LENGTH = 500;
export const SearchInputSkeleton = props => {
  const theme = useTheme();
  const {
    forwardRef,
    features
  } = props;
  const {
    enabled,
    advancedSearchUrl,
    placeholder,
    customScriptDataAttributes
  } = (features === null || features === void 0 ? void 0 : features.interactiveSkeleton) || {};
  if (enabled || getInputSkeletonFocus()) {
    return /*#__PURE__*/React.createElement(SSRsearchInput, {
      advancedSearchUrl: advancedSearchUrl,
      placeholder: placeholder,
      customScriptDataAttributes: customScriptDataAttributes,
      theme: theme
    });
  }
  return /*#__PURE__*/React.createElement(SearchAnchorWrapper, null, /*#__PURE__*/React.createElement(SearchInputContainer, _extends({}, theme, {
    isExpanded: false,
    role: "search"
  }), /*#__PURE__*/React.createElement(MobileSearchIconWrapper, {
    isExpanded: false
  }, /*#__PURE__*/React.createElement(IconButton, {
    label: "",
    icon: () => /*#__PURE__*/React.createElement(SearchIcon, {
      theme: theme,
      isExpanded: false,
      size: "medium"
    })
  })), /*#__PURE__*/React.createElement(DesktopSearchIconWrapper, _extends({}, theme, {
    isExpanded: false
  }), /*#__PURE__*/React.createElement(SearchIcon, {
    theme: theme,
    isExpanded: false
  })), /*#__PURE__*/React.createElement(SearchInputField, _extends({
    "data-test-id": "search-dialog-search-skeleton",
    isExpanded: false,
    placeholder: placeholder,
    ref: forwardRef || undefined,
    disabled: true,
    value: "",
    maxLength: MAX_INPUT_LENGTH,
    onChange: () => {}
  }, theme))));
};
export default /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SearchInputSkeleton, _extends({}, props, {
  forwardRef: ref
})));